(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/legal-info.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/legal-info.js');
'use strict';

const PAYFOOTER_LEGAL = svs.tur.payfooter.constants.PAYFOOTER_LEGAL_INFO;
const LegalInfo = () => React.createElement("div", {
  className: "f-center f-500 padding-1"
}, PAYFOOTER_LEGAL);
svs.tur.ReactPayfooter.LegalInfo = LegalInfo;

 })(window);